"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwErrorIfIsNotCondition = exports.getMinOrMax = exports.getBounds = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
/* add new functions here */

const getMinOrMax = (points, minOrMax, latOrLng) => {
  if (minOrMax === 'max') {
    return Math.max(...points.map(point => point[latOrLng]));
  }
  return Math.min(...points.map(point => point[latOrLng]));
};
exports.getMinOrMax = getMinOrMax;
const getBounds = points => {
  const maxLat = getMinOrMax(points, 'max', 'latitude');
  const minLat = getMinOrMax(points, 'min', 'latitude');
  const maxLng = getMinOrMax(points, 'max', 'longitude');
  const minLng = getMinOrMax(points, 'min', 'longitude');
  const southWest = [minLng, minLat];
  const northEast = [maxLng, maxLat];
  return [southWest, northEast];
};
exports.getBounds = getBounds;
const throwErrorIfIsNotCondition = (condition, message) => {
  if (!condition) {
    throw new Error(message);
  }
};
exports.throwErrorIfIsNotCondition = throwErrorIfIsNotCondition;